export default {
  have_account: 'Ai cont?',
  sign_in: 'Conectează-te',
  sign_in_description: 'pentru a folosi punctele și datele salvate',
  join_free: 'Înscrie-te gratuit',
  join_description: '— câștigă recompense la fiecare comandă',
  join_description_with_discount: `— câștigă recompense de până la <highlight>{{max_discount}} reducere</highlight> la fiecare comandă`,
  join_description_with_product_and_discount: `— câștigă recompense ca {{product_name}} gratuit și până la <highlight>{{max_discount}} reducere</highlight> la fiecare comandă`,
  demo_mode: 'Mod demo',
};
